import {UpdateQueryOptions} from "../../../../common/state/query.actions";

export class UpdateInventoryContractTermsActiveSiderSection {
  static readonly type = '[INVENTORY_CONTRACT_TERMS] Update active sider section';
  constructor(public name: string) {}
}
